import React, { useContext } from 'react';
import { CardWrapper } from '@components/DetailsCard/DetailsCard.styled';
import {
    AmtWrapper,
    NextPayDue,
    PayButton,
    PayLinkWrapper,
    ThanksMsg,
    Wrapper
} from '@components/PaymentComponent/PaymentComponent.styled';
import { WidgetsContext, DataContext } from '@context';
import { ButtonWrapper } from '@components/ServicingLoanDetail/ServicingLoanDetail.styled';
import Link from '@components/Link/Link';
import { CodingConstants } from '@constants/CodingConstants';
import { AmplifyLogs, UIConstants } from '@constants';
import { config } from '../../config';
import { AccountDetailsProps } from '@types';
import { dateFormat, nextPaymentDateDiff } from '@utils/dateFormat';
import { currencyFormat } from '@utils/currency.format';
import {
    AcountDetailsWrapper,
    Separator,
    ContentWrapper,
    PaymentDue,
    DateText,
    CardTitle,
    AmtText,
    MinDueText
} from './AccountDetails.styled';
import ServicingLoanDetail from '@components/ServicingLoanDetail/ServicingLoanDetail';
import { useSelector } from 'react-redux';
import { selectRecurringPayment } from '@store/selectors/autoPay.selector';
//import { useNavigate } from 'react-router-dom';

export const AccountDetails: React.FC<AccountDetailsProps> = ({ account, component, themeType }) => {
    const { accountDetailSSO } = useContext(DataContext);
    const { handleDocument, loanNumber } = useContext(WidgetsContext);

    //const navigate = useNavigate();
    const recurringPay = useSelector(selectRecurringPayment);

    const { nextPaymentDate, accountStatus, totalDue, totalRecurringPayment } = account;
    const { currentAccount, pastDue, monthlyStmt } = CodingConstants;

    const isCurrentAcc = () => {
        if (accountStatus?.name === currentAccount) {
            return true;
        } else return false;
    };

    const isPastDueAcc = () => {
        if (accountStatus?.name === pastDue) {
            return true;
        } else {
            return false;
        }
    };

    const hasPaid = () => {
        if (isCurrentAcc()) {
            if (nextPaymentDateDiff(nextPaymentDate) > 1) {
                return true;
            }
        } else return false;
    };

    const accountDetail = () => {
        accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost`);
    };
    const paynowDetail = () => {
        accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost?target_menu=oneTimePayment`);
    };

    const autoPay = () => {
        accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost?target_menu=recurringPayments`);
    };

    const paymentHistory = () => {
        accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost?target_menu=paymentHistory`);
    };

    const { action, paymentHistoryLink, viewStatementLink, autoPayLink } = AmplifyLogs.paynowWidget;

    const {
        thanksMsg,
        nextDue,
        accountDetails: { titlePastDue, titleCurrentAcc, payDueDate, setAutoPay, payHistory, viewStmt }
    } = UIConstants;

    return (
        <>
            <CardWrapper themeType={themeType}>
                <ContentWrapper>
                    {isPastDueAcc() ? <CardTitle textColor="#CC3736">{titlePastDue}</CardTitle> : <CardTitle>{titleCurrentAcc}</CardTitle>}
                    <AcountDetailsWrapper>
                        <div>
                            {hasPaid() ? (
                                <div>
                                    <ThanksMsg>{thanksMsg}</ThanksMsg>
                                    <NextPayDue>{`${nextDue} ${dateFormat(nextPaymentDate)}`}</NextPayDue>
                                </div>
                            ) : (
                                <Wrapper>
                                    <AmtWrapper>
                                        <AmtText isPastDue={isPastDueAcc()}>{currencyFormat(totalDue)}</AmtText>
                                        {isPastDueAcc() && (
                                            <MinDueText>{`Minimum Due ${currencyFormat(totalRecurringPayment)}`}</MinDueText>
                                        )}
                                        <NextPayDue>
                                            <PaymentDue>{payDueDate}</PaymentDue>
                                            <DateText textColor={isPastDueAcc() ? '#CC3736' : '#222a34'}>{`${dateFormat(
                                                nextPaymentDate
                                            )}`}</DateText>
                                        </NextPayDue>
                                    </AmtWrapper>
                                </Wrapper>
                            )}
                        </div>
                        <div>
                            <ButtonWrapper>
                                <PayButton
                                    onClick={paynowDetail}
                                    text="PAY NOW"
                                    themeType="success_3"
                                    variant="solid"
                                    eventAttributes={{ type: component, action, description: action }}
                                    // data-testid="payNow"
                                />
                                <PayLinkWrapper>
                                    <div data-testid="autoPay">
                                        {!recurringPay && (
                                            <Link
                                                onClick={autoPay}
                                                eventAttributes={{
                                                    type: component,
                                                    action: autoPayLink,
                                                    description: 'Set Up AutoPay button was clicked',
                                                    loanNumber
                                                }}
                                            >
                                                {setAutoPay}
                                            </Link>
                                        )}
                                    </div>
                                    <Link
                                        data-testid="paymentHistory"
                                        onClick={paymentHistory}
                                        eventAttributes={{
                                            type: component,
                                            action: paymentHistoryLink,
                                            loanNumber,
                                            description: 'View Payment History button was clicked'
                                        }}
                                    >
                                        {payHistory}
                                    </Link>
                                    <Link
                                        id="viewStatementsLink"
                                        onClick={() => handleDocument(monthlyStmt, account?.accountNumber)}
                                        data-testid="viewStatementsLink"
                                        eventAttributes={{
                                            type: component,
                                            action: viewStatementLink,
                                            loanNumber,
                                            description: 'View Current Statement button was clicked'
                                        }}
                                    >
                                        {viewStmt}
                                    </Link>
                                </PayLinkWrapper>
                            </ButtonWrapper>
                        </div>
                    </AcountDetailsWrapper>
                    <Separator />
                    <ServicingLoanDetail account={account} accountDetails={accountDetail} component={component} />
                </ContentWrapper>
            </CardWrapper>
        </>
    );
};
